import { useContext } from 'react';
import { PermissionsContext } from '../provider/PermissionsProvider';

const usePermission = () => {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error('usePermissions must be used within a PermissionsProvider');
  }
  return context;
};

export default usePermission;
